// extracted by mini-css-extract-plugin
export var deleteModal = "_rs-0";